import icon1 from './floating+icons/Frame 29.svg';
import icon2 from './floating+icons/Frame 30.svg';
import icon3 from './floating+icons/Frame 31.svg';
import appleBadge from './landingPage/appstore+badge.svg';
import downloadIcon from './landingPage/download-01.svg';
import image6 from './landingPage/Event#1.png';
import image7 from './landingPage/Event#2.png';
import image8 from './landingPage/Event#3.png';
import image15 from './landingPage/gigs.png';
import image1 from './landingPage/Group 13.png';
import image2 from './landingPage/Group 26.png';
import image3 from './landingPage/Group 27.png';
import image4 from './landingPage/Group 29.png';
import image16 from './landingPage/Group38.png';
import image17 from './landingPage/Group45.png';
import image5 from './landingPage/Jumbotron+img.png';
import image10 from './landingPage/mockup#2.png';
import image11 from './landingPage/mockup#3.png';
import image12 from './landingPage/mockup#4.png';
import image13 from './landingPage/mockup#5.png';
import image14 from './landingPage/mockup#6.png';
import image9 from './landingPage/mockup1.png';
import background from './landingPage/musicade+background.jpg';
import background2 from './landingPage/Property1.jpg';
import background3 from './landingPage/Property2.jpg';
import background4 from './landingPage/Property3.jpg';


import landscapeLogo from './landingPage/Musicade+logo+landscape.svg';




import LOGO from './LOGO.png';
 

 

const rawHomePageAssets = {
  icon1,
  icon2,
  icon3,
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
appleBadge,
  LOGO,
  downloadIcon,
  background,
  landscapeLogo,
  background2,
  background3,
  background4,

};

export const HomePageAssets: Record<string, string> = Object.fromEntries(
  Object.entries(rawHomePageAssets).map(([k, v]) => [k, (v as string).replace(/#/g, '%23')])
) as Record<string, string>;